<template>
  <section id="user-list">
    <b-breadcrumb
      :items="breadcrumb"
    />

    <b-row>
      <b-col cols="12">
        <b-card-actions
          ref="filters"
          title="Filtros"
          class="form-filters"
          :action-close="false"
          :action-refresh="false"
          :action-collapse="true"
          @refresh="refreshStop('cardAction')"
        >
          <b-row>
            <b-col cols="3">
              <b-form-group
                label="Nome / E-mail / Telefone / Id"
                label-for="name"
              >
                <b-form-input
                  id="name"
                  v-model="filtersValues.name_or_email"
                  @keyup.enter="getUsers"
                  @keyup="refreshNameFilter"
                />
                <small class="d-block text-right">{{ applyFilterIn }}</small>
              </b-form-group>
            </b-col>

            <b-col cols="3">
              <b-form-group
                label="Tipo"
                label-for="filter_type"
              >
                <b-form-select
                  id="filter_type"
                  v-model="filtersValues.type"
                  :options="filtersOptions.type"
                />
              </b-form-group>
            </b-col>

            <b-col cols="3">
              <b-form-group
                label="Status"
                label-for="filter_status"
              >
                <b-form-select
                  id="filter_status"
                  v-model="filtersValues.status"
                  :options="filtersOptions.status"
                />
              </b-form-group>
            </b-col>

            <b-col
              cols="3"
              class="form-buttons"
            >
              <b-form-group
                label=""
                label-for="btn-buscar"
                style="margin-top: 20px"
              >
                <b-button
                  id="btn-buscar"
                  variant="primary"
                  @click="searchAndResetPage"
                >
                  Buscar
                </b-button>

                <b-button
                  id="btn-limpar"
                  variant="outline-secondary"
                  @click="reset()"
                >
                  Limpar
                </b-button>
              </b-form-group>
            </b-col>

            <b-col
              v-if="filtersValues.status === 'blocked'"
              cols="3"
            >
              <b-form-group
                label="Status"
                label-for="filter_status_reason"
              >
                <b-form-select
                  id="filter_status"
                  v-model="filtersValues.status_reason"
                  :options="filtersOptions.status_reason"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col
              cols="12"
              class="text-right"
            >
              <b-button
                variant="flat-primary"
                :to="{ name: 'cms-user-v2', params: { } }"
                class="font-small-1"
              >
                Tela v2
              </b-button>
            </b-col>
          </b-row>
        </b-card-actions>

        <b-card>
          <b-row
            class="header-card"
            align-v="center"
          >
            <b-col>
              <h4>
                Resultados
              </h4>
            </b-col>

            <b-col class="text-right">
              <b-button
                variant="primary"
                :to="{ name: 'cms-user-form-insert' }"
              >
                <span class="text-nowrap">Adicionar Usuário</span>
              </b-button>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <b-table
                :busy="isLoading"
                fixed
                :items="results"
                :fields="result_fields"
                sort-icon-left
                no-local-sorting
                :sort-by.sync="filtersValues.sortBy"
                :sort-desc.sync="filtersValues.sortDesc"
                @sort-changed="sortingChanged"
              >
                <template #table-busy>
                  <div class="text-center table-spinner">
                    <b-spinner label="Loading..." />
                    <strong>Carregando...</strong>
                  </div>
                </template>

                <template #head(type)>
                  <div class="text-nowrap">
                    Tipo
                  </div>
                </template>

                <template #head(status)>
                  <div class="text-nowrap">
                    Status
                  </div>
                </template>

                <template #head(name)>
                  <div class="text-nowrap">
                    Nome
                  </div>
                </template>

                <template #head(phone)>
                  <div class="text-nowrap">
                    Telefones
                  </div>
                </template>

                <template #head(email)>
                  <div class="text-nowrap">
                    E-mail
                  </div>
                </template>

                <template #head(created_at)>
                  <div class="text-nowrap">
                    Cadastro
                  </div>
                </template>

                <template #head(actions)>
                  <div class="text-nowrap text-center">
                    Ações
                  </div>
                </template>

                <template #cell(email)="row">
                  <div
                    v-if="row.item.list_emails"
                  >
                    <span
                      v-for="email in row.item.list_emails"
                      :key="`email-${email.id}`"
                      class="multiple-lines"
                    >
                      {{ email.email }}
                      <feather-icon
                        v-if="email.verified_at"
                        animation="spin-pulse"
                        class="text-success"
                        icon="CheckIcon"
                        :title=" `Confirmado em ${formatDateTimeDbToView(email.verified_at)}` "
                      />
                    </span>
                  </div>
                  <div
                    v-if="row.item.emails_cms"
                  >
                    <span
                      v-for="(emailcms, k) in row.item.emails_cms"
                      :key="`emailcms-${k}`"
                      class="multiple-lines"
                    >
                      {{ emailcms }}
                    </span>
                  </div>
                </template>

                <template #cell(phone)="row">
                  <div
                    v-if="row.item.list_phones"
                  >
                    <span
                      v-for="phone in row.item.list_phones"
                      :key="`phone-${phone.id}`"
                      class="multiple-lines"
                    >
                      {{ phone.complete | phone }}
                      <feather-icon
                        v-if="phone.verified_at"
                        animation="spin-pulse"
                        class="text-success"
                        icon="CheckIcon"
                        :title=" `Confirmado em ${formatDateTimeDbToView(phone.verified_at)}` "
                      />
                    </span>
                  </div>
                  <div
                    v-if="row.item.phones_cms"
                  >
                    <span
                      v-for="(phonecms, k) in row.item.phones_cms"
                      :key="`phonecms-${k}`"
                      class="multiple-lines"
                    >
                      {{ phonecms }}
                    </span>
                  </div>
                </template>

                <template #cell(type)="row">
                  {{ $t(`users.columns.type.${row.item.type}`) }}
                </template>

                <template #cell(status)="row">
                  <div v-if="row.item.deleted_at === null">
                    {{ $t(`users.columns.status.${row.item.status}`) }} <span v-if="row.item.status !== 'basic' && row.item.status !== 'review'"><br>{{ row.item.plan_group_name }} {{ row.item.payment_interval ? ' - ' + $t(`financial.columns.payment_interval.${row.item.payment_interval}`) : '' }}</span>
                  </div>
                  <div v-else>
                    <span class="text-danger">REMOVIDO</span>
                  </div>
                </template>

                <template #cell(created_at)="row">
                  {{ formatDateTimeDbToView(row.item.created_at) }}
                </template>

                <template #cell(actions)="row">
                  <div class="text-nowrap text-center">
                    <b-button
                      v-if="$can('read', 'Users')"
                      variant="flat-primary"
                      :to="{ name: 'cms-user-form-update', params: { id: row.item.id } }"
                      title="Editar"
                      target="_blank"
                    >
                      <feather-icon
                        icon="EditIcon"
                        size="16"
                        class="align-middle text-body"
                      />
                    </b-button>

                    <b-button
                      v-if="$can('delete', 'Users')"
                      variant="flat-primary"
                      title="Deletar"
                      :disabled="row.item.deleted_at !== null"
                      @click="deleteUser(row.item.id)"
                    >
                      <feather-icon
                        icon="TrashIcon"
                        size="16"
                        class="align-middle text-body"
                      />
                    </b-button>
                  </div>
                </template>

                <template #row-details="row">
                  <b-spinner v-if="!row.item.message" />
                  <p>{{ row.item.message }}</p>
                </template>

              </b-table>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="6">
              <p>Mostrando {{ pages.from }} até {{ pages.to }} de {{ pages.total }} resultados</p>
            </b-col>

            <b-col cols="6">
              <!-- pagination nav -->
              <b-pagination-nav
                v-model="currentPage"
                :number-of-pages="pages.last_page"
                :link-gen="() => { return '#' }"
                align="end"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>

    </b-row>

  </section>
</template>

<script>
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import UserService from '@/services/userService'
import { formatDateTimeDbToView } from '@/utils/helpers'
// import moment from 'moment'
import {
  BRow,
  BCol,
  BTable,
  BFormInput,
  BFormGroup,
  BFormSelect,
  BPaginationNav,
  BSpinner,
  BButton,
  // BModal,
  BCard,
  BBreadcrumb,
} from 'bootstrap-vue'
// import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  userTypes, userStatus, userBlockReasons,
} from '@/utils/options'

export default {
  components: {
    BCardActions,
    BCard,
    BRow,
    BCol,
    BTable,
    BFormInput,
    BFormGroup,
    BFormSelect,
    BPaginationNav,
    BSpinner,
    BButton,
    // BModal,
    BBreadcrumb,
    // vSelect,
  },

  data() {
    return {
      userService: null,
      isLoading: true,
      breadcrumb: [
        {
          text: 'Dashboard',
          to: { name: 'cms-dashboard' },
        },
        {
          text: 'Usuários',
          active: true,
        },
      ],

      nameFilter: '',
      applyFilterIn: '',
      filtersInitialValues: {},
      filtersValues: {
        name_or_email: '',
        type: 'all',
        status: 'all',
        status_reason: 'all',
        sortBy: 'id',
        sortDesc: true,
      },
      filtersOptions: {
        status: [
          { value: 'all', text: 'Todos' },
          ...userStatus,
        ],
        type: [
          { value: 'all', text: 'Todos' },
          ...userTypes,
        ],
        status_reason: [
          { value: 'all', text: 'Todos' },
          ...userBlockReasons,
        ],
      },

      pages: 1,
      currentPage: 1,
      results: [],
      result_fields: [],
      formatDateTimeDbToView,
    }
  },

  watch: {
    currentPage() {
      this.getUsers()
    },
  },

  created() {
    this.userService = new UserService()
    this.getUsers()
    this.filtersInitialValues = { ...this.filtersValues }

    this.result_fields = [
      { key: 'id', sortable: true, thStyle: 'width: 100px' },
      { key: 'name', sortable: true },
      { key: 'phone', sortable: true, thStyle: 'width: 150px' },
      { key: 'email', sortable: true },
      { key: 'created_at', sortable: true, thStyle: 'width: 110px' },
      { key: 'status', sortable: true, thStyle: 'width: 120px' },
      { key: 'type', sortable: true, thStyle: 'width: 145px' },
    ]

    if (this.showActions()) {
      this.result_fields.push({ key: 'actions', sortable: false, thStyle: 'width: 150px' })
    }
  },

  methods: {
    reset() {
      this.filtersValues = JSON.parse(JSON.stringify(this.filtersInitialValues))
      this.getUsers()
    },

    searchAndResetPage() {
      if (this.currentPage !== 1) {
        this.currentPage = 1
      } else {
        this.getUsers()
      }
    },

    sortingChanged(ctx) {
      this.filtersValues.sortBy = ctx.sortBy
      this.filtersValues.sortDesc = ctx.sortDesc
      this.getUsers()
    },

    showActions() {
      return this.$can('read', 'Users') || this.$can('update', 'Users') || this.$can('delete', 'Users')
    },

    deleteUser(userId) {
      this.$swal({
        title: 'Deletar usuário?',
        text: 'Esta ação não poderá ser desfeita!',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sim, deletar!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.isLoading = true
          this.userService.delete(userId).then(response => {
            this.isLoading = false
            if (response.status === 200) {
              this.results = this.results.filter(filter => filter.id !== userId)
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: `Usuário ${userId} removido!`,
                  icon: 'CheckCircleIcon',
                  variant: 'success',
                  // text: `!`,
                },
              })
            }
          })
        }
      }).catch(error => {
        this.isLoading = false
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Erro!',
            text: error.response.data.message,
            icon: 'BellIcon',
            variant: 'danger',
          },
        })
      })
    },

    refreshNameFilter(e) {
      let applyFilterIn = ''
      const { value } = e.target
      if (value.replace(/[^0-9]/, '').length === value.length) {
        applyFilterIn = `${applyFilterIn}${applyFilterIn.length ? ', ' : ''} ID`
        if (value.length >= 6) {
          applyFilterIn = `${applyFilterIn}${applyFilterIn.length ? ', ' : ''} Telefone, CPF e CNPJ`
        }
      } else if (value.replace(/[@]/, '').length !== value.length) {
        applyFilterIn = `${applyFilterIn}${applyFilterIn.length ? ', ' : ''} E-mail`
      } else {
        applyFilterIn = `${applyFilterIn}${applyFilterIn.length ? ', ' : ''} Nome, E-mail`
      }

      this.applyFilterIn = `Pesquisa no campo: ${applyFilterIn}`
    },

    getUsers() {
      this.isLoading = true
      this.userService.list(this.filtersValues, this.currentPage).then(response => {
        if (response.data !== null) {
          const users = response.data.data.users.data.map(
            m => ({
              ...m,
              plan_group_name: (m.last_plan !== null) ? m.last_plan.split(',')[0] : '',
              payment_interval: (m.last_plan !== null) ? m.last_plan.split(',')[1] : '',
              list_phones: m.list_phones.sort((a, b) => (a.master < b.master ? 1 : -1)),
              list_emails: m.list_emails.sort((a, b) => (a.master < b.master ? 1 : -1)),
            }),
          )
          this.results = users

          this.pages = response.data.data.users
          delete this.pages.data
        }
        this.isLoading = false
      })
    },

  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#user-list {
  .b-table{
    td{
      padding: 0.5rem 1rem;
    }
  }

  .multiple-lines{
    display:block;
  }

  .multiple-lines-email{
    margin-top: 5px;
    display:block;
  }

  .header-card {
    margin-bottom: 20px;
  }

  .form-buttons button {
    margin-right: 10px;
  }
}
</style>
